// @flow
import React, { Component } from 'react';
import {
  LgDesktop,
  Default,
  Desktop,
  Mobile,
  Device
} from '../../../../components/Responsive';
import { history } from '../../../../utilities/history';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import InfoTooltip from '../../../../components/InfoTooltip';
import { type Merchant, type Currencies } from '../../../../utilities/types';
import {
  CustomModelListTd,
  SubtitleP,
  TableRowAlignmentDiv
} from '../../../../modules/CrudTable/CrudTableStyles';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';
import { CustomSpan, SubtitleWrapper } from './DirectMerchantsIndexStyles';
import { formatDate } from '../../../../utilities/misc';
type Props = {
  merchant: Merchant,
  showTooltip: (tooltip: string) => void,
  activeTooltip: ?string,
  currencies: Currencies,
  setActiveSubsection?: (subsection: number) => void,
  showMostRecentOnly?: boolean
};

export default class DirectMerchantRow extends Component<Props> {
  handleRowClick = () => {
    if (this.props.showMostRecentOnly) {
      // $FlowFixMe
      this.props.setActiveSubsection(this.props.merchant.id);
    } else {
      history.push(`/merchants/${this.props.merchant.id}`);
    }
  };

  displayStatus = () => {
    const applicationStatus = this.props.merchant.application_status;
    const statusObj = {
      new: {
        text: 'New',
        color: 'blue',
        tooltipMessage: 'New account, email confirmed'
      },
      partial: {
        text: 'Partial',
        color: 'orange',
        tooltipMessage: 'Partially filled merchant application'
      },
      pending: {
        text: 'Pending',
        color: 'yellow',
        tooltipMessage: 'Waiting on KYC/AML approval'
      },
      approved: {
        text: this.props.merchant.documents_verified
          ? 'Approved'
          : 'Partially Approved',
        tooltipMessage: this.props.merchant.documents_verified
          ? 'Merchant application approved'
          : 'Merchant application partially approved',
        color: 'green'
      },
      denied: {
        text: 'Denied',
        color: 'red',
        tooltipMessage: this.props.merchant.denied_reason
      }
    };
    return statusObj[applicationStatus] || {};
  };

  statusColor = () => this.displayStatus().color;
  tooltipMessage = () => this.displayStatus().tooltipMessage;
  statusText = () => this.displayStatus().text;

  render() {
    let status = this.props.merchant.application_status;
    if (status === 'partial') {
      status = 'partially filled';
    }
    return (
      <DefaultModelRowTr hoverStyles onClick={this.handleRowClick}>
        <LgDesktop>
          <CustomModelListTd>
            <TableRowAlignmentDiv />
            {this.props.merchant.id}
          </CustomModelListTd>
          <CustomModelListTd>
            <TableRowAlignmentDiv />
            {formatDate(this.props.merchant.created_at)}
          </CustomModelListTd>
        </LgDesktop>
        <CustomModelListTd bold overflow>
          {!this.props.merchant.email && <TableRowAlignmentDiv />}
          {this.props.merchant.business_name}
          <Mobile>
            <SubtitleWrapper>
              <SubtitleP firstCapital color={this.statusColor()}>
                {this.statusText()}
              </SubtitleP>
              <InfoTooltip
                showTooltip={this.props.showTooltip}
                activeTooltip={this.props.activeTooltip}
                tooltipName={`DIRECT_MERCHANT${this.props.merchant.id}_APPLICATION_STATUS2`}
                message={this.tooltipMessage()}
                smallIcon
                iconColor={this.statusColor()}
              />
            </SubtitleWrapper>
          </Mobile>
          <Default>
            <SubtitleP color="dustyGray">{this.props.merchant.email}</SubtitleP>
          </Default>
        </CustomModelListTd>
        <Default>
          <CustomModelListTd color={this.statusColor()} firstCapital overflow>
            <TableRowAlignmentDiv />
            <CustomSpan>{this.statusText()}</CustomSpan>
            <InfoTooltip
              showTooltip={this.props.showTooltip}
              activeTooltip={this.props.activeTooltip}
              tooltipName={`DIRECT_MERCHANT${this.props.merchant.id}_APPLICATION_STATUS`}
              message={this.tooltipMessage()}
              smallIcon
            />
          </CustomModelListTd>
        </Default>
        <CustomModelListTd right>
          <Desktop>
            <TableRowAlignmentDiv />
          </Desktop>
          {formatCurrency(
            this.props.merchant.total_processing_vol_usd,
            this.props.currencies['USD']
          )}
          <Device>
            <SubtitleP color="dustyGray">
              Fees:{' '}
              {formatCurrency(
                this.props.merchant.total_fees_usd,
                this.props.currencies['USD']
              )}
            </SubtitleP>
          </Device>
        </CustomModelListTd>
        <Desktop>
          <CustomModelListTd right>
            <TableRowAlignmentDiv />
            {formatCurrency(
              this.props.merchant.total_fees_usd,
              this.props.currencies['USD']
            )}
          </CustomModelListTd>
        </Desktop>
      </DefaultModelRowTr>
    );
  }
}
